

const keys = Object.keys;
const create = Object.create;
const isArray = Array.isArray;

const forceArray = function(values) {
    return isArray(values) ? values : [values];
};

const copyAttributes = function(target, other) {
    keys(other).forEach(function(key) {
        target[key] = other[key];
    });
};

export default function Class(def) {
    const base = def.Extends || null;
    delete def.Extends;

    const implemented = forceArray(def.Implements || []);
    delete def.Implements;

    const init = def.initialize || base || null;
    delete def.initialize;

    const proto = create(base ? base.prototype : null);
    implemented.forEach(function(obj) {
        copyAttributes(proto, obj.prototype);
    });
    copyAttributes(proto, def);

    const Cls = !init ? function() {} : function() {
        return init.apply(this, arguments);
    };

    proto.constructor = Cls;
    Cls.prototype = proto;
    return Cls;
}



// WEBPACK FOOTER //
// ./src/abusesa-js/Class.js